module.exports = __webpack_public_path__ + "img/img5.33e43e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img5.jpg
// module id = 341
// module chunks = 0